import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import DocumentForm from '../../components/DocumentForm'
import { MAIN_LANG } from '../../consts'
import { useDeleteDoc, useDoc, useUpdateDoc } from '../../hooks/docs'
import { DocDetail } from '../../types'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'

export default function DocumentEdit() {
  const { id } = useParams()
  const { data: doc } = useDoc(+id!)
  const updateDoc = useUpdateDoc()
  const deleteDoc = useDeleteDoc()
  const [modalRm, modalRmActions] = useModalTrigger<DocDetail>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/documents">Documenti</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {doc!.title[MAIN_LANG]}
            </li>
          </ol>
        </nav>
        <button
          className="btn btn-danger"
          onClick={() => modalRmActions.open(doc)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <DocumentForm
          doc={doc}
          save={(formDoc) =>
            updateDoc.mutateAsync(formDoc).then(() =>
              toast.success('Documento salvato con successo!', {
                position: 'bottom-right',
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il Documento{' '}
              {modalRm.value.title[MAIN_LANG]} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteDoc.isLoading}
            onClick={async () => {
              await deleteDoc.mutateAsync(modalRm.value!.id)
              navigate('/documents')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
